export const DEFAULT_NEO_POSTER_IMAGE = 'https://staging.cdn.apisystem.tech/assets/membership/membership-icons/default-course-image.svg'

export const DEFAULT_POSTER_IMAGE = 'https://staging.cdn.apisystem.tech/assets/membership/empty-course-poster.webp'

export const DEFAULT_HEADSHOT = 'https://staging.cdn.apisystem.tech/assets/membership/user-avatar.svg'

export const FIREBASE_STORAGE_BASE_URL = 'https://firebasestorage.googleapis.com'

export const LOCKED_CONTENT_IMAGE = 'https://staging.cdn.apisystem.tech/assets/membership/locked-lesson.webp'

export const ASSESSMENT_SUCCESS_IMAGE = 'https://staging.cdn.apisystem.tech/assets/membership/assessment-success.webp'

export const ASSESSMENT_FAIL_IMAGE = 'https://staging.cdn.apisystem.tech/assets/membership/assessment-fail.webp'

export const ASSESSMENT_UNDER_REVIEW_IMAGE = 'https://staging.cdn.apisystem.tech/assets/membership/assessment-review.webp'

export const DEFAULT_COURSE_THUMBNAIL = 'https://staging.cdn.apisystem.tech/assets/membership/image-placeholder.svg'

export const DEFAULT_CERTIFICATE_THUMBNAIL_LOCKED =
  'https://storage.googleapis.com/revex-membership-staging/assets/default_certificate_post_thumbnail'

export const DEFAULT_CERTIFICATE_THUMBNAIL =
  'https://storage.googleapis.com/revex-membership-staging/assets/certificate-default-poster.webp'

export const DEFAULT_QUIZ_THUMBNAIL = 'https://storage.googleapis.com/revex-membership-staging/assets/quiz-default-poster.webp'

export const CHECKOUT_COURSE_LOGO = 'https://staging.cdn.apisystem.tech/assets/membership/checkout-course-logo.webp'

export const ASSESSMENT_DEFAULT_IMAGE = 'https://staging.cdn.apisystem.tech/assets/membership/assessment-default-poster.webp'

export const EXPIRED_COURSE_IMAGE = 'https://storage.googleapis.com/revex-membership-staging/assets/expired-course.webp'

export const NO_SEARCH_RESULTS_IMAGE = 'https://storage.googleapis.com/revex-membership-staging/assets/no-results.webp'

export const DEFAULT_COURSE_POSTER = 'https://staging.cdn.apisystem.tech/assets/membership/default-course-poster.webp'

export const DEFAULT_COURSE_LOGO = 'https://staging.cdn.apisystem.tech/assets/membership/default-course-logo.webp'

export const EMPTY_DESCRIPTION_IMAGE = 'https://storage.googleapis.com/revex-membership-staging/assets/empty-description.webp'

export const ASSIGNMENT_ATTACHMENT_LIMITATIONS = {
  MAX_FILE_SIZE: 100 * 1024 * 1024, // 100MB
  MAX_NUMBER_OF_FILES: 10,
  ACCEPTED_FILE_TYPES: '.xlsx,.doc,.docx,.ppt,.pptx,.pdf,.svg+xml,.svg,.png,.webp,.jpg,.jpeg,.mp4,.mov,.mp3',
}
